import { urlPrefix } from '../clientConfig';

let env = window.REACT_APP_ENV;
if (env === 'prod') env = '';
const devApiUrl = env !== 'production' ? window.REACT_APP_API_SITE : '';

export default () => `${devApiUrl}${urlPrefix}`;
